import { sleep } from "effection";
import {
  ApiCtx,
  call,
  Next,
  Operation,
  safe,
  select,
  spawn,
  takeLeading,
  useAbortSignal,
} from "starfx";

import { dateToSqlDate, ensureArray } from "@app/service/helpers";

import { identityResult, isErr, isOk, isResultLikeErr } from "../helpers";
import { runThunk, safeLast } from "../helpers/fxhelpers";
import { schema } from "../schema";
import { xApi } from "../xapis";
import { sfxNotify } from "./notify";

export const nmodReadDirOfDownloadCode = xApi.get<string>(
  "nMode/efct/read_dir_of_dowcode",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    const downloadCode = ctx.payload;
    const params_ = JSON.parse(downloadCode);
    const params = new URLSearchParams(params_);
    ctx.request = ctx.req({
      url: `/efactura/read_dir_of_dowcode?${params}`,
      method: "GET",
    });
    yield* next();
  }
);

export function* nmEfacturaOpenDir(dowloadCode: string) {
  yield* sleep(1);
  return dowloadCode;
}
export function* nmEfacturaOpenPdf(path: string, suggestedName: string) {
  yield* sleep(1);
  return path;
}
export function* nmEfacturaPrepareDir(jsonRecord: string) {
  yield* sleep(1);
  return jsonRecord;
}
export function* nmEfacturaParseXml(jsonRecord: string) {
  yield* sleep(1);
  return jsonRecord;
}

export function* nmEfacturaCleanupLocalDir(jsonRecord: string) {
  yield* sleep(1);
  return jsonRecord;
}
export function* nmEfacturaCleanupServerFiles(jsonRecord: string) {
  yield* sleep(1);
  return jsonRecord;
}
export function* nmEfacturaCleanupMessageTree(jsonRecord: string) {
  yield* sleep(1);
  return jsonRecord;
}
export function* nmEfacturaProcessUnknown(sqlDate: string) {
  yield* sleep(1);
  return sqlDate;
}
export function* nmEfacturaStartProcess(sqlDate: string) {
  yield* sleep(1);
  return sqlDate;
}
export function* nmEfacturaStopProcess(pid: string) {
  yield* sleep(1);
  return pid;
}
export function* nmEfacturaBringToLocal(path: string) {
  yield* sleep(1);
  return path;
}
export function* nmEfacturaReadFullDirtreeOfBase(base: string) {
  yield* sleep(1);
  return base;
}
export function* nmEfacturaOpenFXMLDetailsForm(jsonRecord: string) {
  yield* sleep(1);
  return jsonRecord;
}
